import { Stack } from "react-bootstrap"
import MenuButton from "./MenuButton"
import { PagesDefinition } from "../App"

const Menu = ({selected="", onSelected=(id:string) => {}}) => {
    const onClicked = (_selected?:string) => {
        onSelected(_selected!)
    }
    return <Stack className="menu-container" gap={0}>
        {
            PagesDefinition.map((item) => 
                <MenuButton 
                    key={item.id}
                    Icon={item.icon}
                    id={item.id} 
                    checked={item.id===selected}
                    onClicked={
                        (id) => {
                            if (item.sub === null)
                                onClicked(id)
                        }
                    }
                    text={item.label}>
                    {item.sub !== null && 
                        <>
                        {item.sub.map( subMenu => 
                            <MenuButton 
                                id={subMenu.id} 
                                text={subMenu.label}
                                checked={subMenu.id===selected} 
                                onClicked={onClicked}/>)}
                        </>}
                </MenuButton>)
        }
    </Stack>
}

export default Menu